import { render, staticRenderFns } from "./RecluimentView.vue?vue&type=template&id=1ec5f71e&scoped=true"
import script from "./RecluimentView.vue?vue&type=script&lang=js"
export * from "./RecluimentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec5f71e",
  null
  
)

export default component.exports